import { SpecialOfferProps } from '../types';
import { ProductsBackground, StyledFrame, StyledSpecialOffer } from './style';
import { BundlePrice } from 'components/BundlePrice';
import { EBadgeType, EBundlesInternalViewModel } from 'utils/enums';
import { Box } from '@mui/system';
import { GhostProduct } from './Products/GhostProduct';
import React, { useEffect, useState } from 'react';
import { ProductData } from 'utils/types';
import { BadgeData, IEmblemBadge } from 'components/Badge/types';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { useGetBadge } from 'utils/useGetBadge';

export const GhostSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  productsList,
  availability,
  backgroundColor,
  backgroundImage,
  selectOffer,
  isFree,
  collectText,
  availabilityText = 'Available',
  timer,
  badges = [],
  emblemBadges = [],
}) => {
  const [products, setProducts] = useState<ProductData[]>([]);
  const [emblemBadgeOld, setEmblemBadgeOld] = useState<any>(null);
  const emblemBadgeNew = useGetBadge<IEmblemBadge>(emblemBadges);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadgeOld(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadgeOld(null);
    }
  }, [badges]);

  const emblemBadge = emblemBadgeNew ?? emblemBadgeOld;

  useEffect(() => {
    if (!productsList || productsList.length === 0) return;
    setProducts(productsList.slice(0, 2));
  }, [productsList]);

  return (
    <StyledFrame onClick={selectOffer}>
      <StyledSpecialOffer
        backgroundColor={backgroundColor}
        backgroundImage={backgroundImage}
      >
        {emblemBadge && (
          <div className="ghost-emblem">
            <img
              className="ghost-emblem--badge"
              alt="emblem-badge"
              src={emblemBadge.imageUrl}
            />
          </div>
        )}
        <div className="frame">
          <ProductsBackground
            backgroundColor={
              backgroundColor ? backgroundColor?.colorOne : '#C5AEFF'
            }
          >
            {products.map((product, index) => (
              <GhostProduct
                key={index}
                productImage={product.images.product}
                quantityDisplay={product.quantityDisplay}
                textColor={product.textFontColorHex}
                suffix={product.suffix}
              />
            ))}
          </ProductsBackground>
          {timer && <span className="timeLeft">Ends in {timer}</span>}
          <Box className="price-container">
            <AutoTextSize
              as="div"
              maxFontSizePx={16}
              minFontSizePx={4}
              mode="oneline"
            >
              <BundlePrice
                prices={prices}
                type={EBundlesInternalViewModel.GHOST}
                isFree={isFree}
                buttonText={collectText}
              />
            </AutoTextSize>
          </Box>
          {availabilityText && availability && (
            <span className="availability">
              {availabilityText} {availability.remaining}/{availability.total}
            </span>
          )}
        </div>
      </StyledSpecialOffer>
    </StyledFrame>
  );
};
